import { logUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Logs the root folder click and its current expansion state.
 * @param distinguishedFolderId
 * @param mailboxInfo
 * @param isExpanded - whether the folder node is currently expanded (before the toggle)
 */
export default function logRootFolderNodeClick(
    distinguishedFolderId: string,
    mailboxInfo: MailboxInfo,
    isExpanded: boolean
): void {
    logUsage('Triage_ToggleFolderExpansion', mailboxInfo, [distinguishedFolderId, isExpanded]);
}
